import { getHeader } from 'commons/helper';
import { SingleAppDTOType } from 'features/dashboard/types';
import axios from 'lib/axios';

export const compileSSDKFile = async (appVersionId: string | number) => {
  return await axios.get(
    `/ssdk/compile?appVersionId=${appVersionId}`,
    getHeader()
  );
};

export const zipSSDKFile = async (appVersionId: string | number) => {
  return await axios.get(`/ssdk/zip?appVersionId=${appVersionId}`, {
    ...getHeader(),
    responseType: 'arraybuffer'
  });
};

export const saveSSDKFile = async (formattedPayload: SingleAppDTOType) => {
  return await axios.post('/ssdk/save', formattedPayload, getHeader());
};
